module.exports = __webpack_public_path__ + "static/media/achievements.cf88a9f2.png";